import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BlackArrowClient } from '@wix/js-black-arrow-client/dist/src/black-arrow-client';
import { WEB_SOCKET_EVENTS } from '@wix/js-black-arrow-client/dist/src/constants';
import { isEditorX } from '../editor-type';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
const tokenHost = isEditorX() ? PRODUCTION_HOSTS.filesEditorX : PRODUCTION_HOSTS.files;
const defaultConfig = {
  socketUrl: 'wss://ws.wixmp.com/ws',
  tokenUrl: tokenHost + "/users/get-batoken"
};
export class BlackArrow {
  constructor(messageHandler) {
    _defineProperty(this, "blackArrow", void 0);
    _defineProperty(this, "initPromise", void 0);
    _defineProperty(this, "messageHandler", void 0);
    this.blackArrow = new BlackArrowClient();
    this.messageHandler = messageHandler;
  }
  async init(config) {
    if (this.initPromise) {
      return this.initPromise;
    }
    this.blackArrow.on(WEB_SOCKET_EVENTS.MESSAGE, message => {
      this.messageHandler(message);
    });
    this.initPromise = this.blackArrow.init({
      ...defaultConfig,
      ...config
    });
    return this.initPromise;
  }
  destroy() {
    this.blackArrow.destroy();
    delete this.initPromise;
    return this;
  }
}
export function createBlackArrow(messageHandler) {
  return new BlackArrow(messageHandler);
}
//# sourceMappingURL=black-arrow.js.map